// extracted by mini-css-extract-plugin
export default {"container":"supporting-documents_container__v7uV-","marginTop":"supporting-documents_marginTop__IWmwB"};